import { createAsyncThunk } from "@reduxjs/toolkit";
import { 
  createSignin,
  createSignup, 
  createForgotPassword, 
  createResetPassword, 
  createGoogleSignin,
  createGoogleSignup,
  createLinkedInSignin,
  createLinkedInSignup,
  verifyAccount,
  resendVerification
} from "../../Api/authentication";

export const signinAuthentication = createAsyncThunk(
  "auth/signin",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await createSignin(userData);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const signupAuthentication = createAsyncThunk(
  "auth/signup",
  async (userData, { rejectWithValue }) => {
    try {
        
      const response = await createSignup(userData);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const forgotPasswordAuthentication = createAsyncThunk(
  "auth/forgotPassword",
  async (data, { rejectWithValue }) => {
    try {
      const response = await createForgotPassword(data);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const resetPasswordAuthentication = createAsyncThunk(
  "auth/resetPassword",
  async (data, { rejectWithValue }) => {
    try {
      const response = await createResetPassword(data);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const googleSigninAuthentication = createAsyncThunk(
    "auth/googleSignin",
    async (tokenData, { rejectWithValue }) => {
      try {
        const response = await createGoogleSignin(tokenData);
        return response;
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    }
  );
  
  export const googleSignupAuthentication = createAsyncThunk(
    "auth/googleSignup",
    async (tokenData, { rejectWithValue }) => {
      try {
        const response = await createGoogleSignup(tokenData);
        return response;
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    }
  );
  
  // LinkedIn SSO actions
  export const linkedInSigninAuthentication = createAsyncThunk(
    "auth/linkedInSignin",
    async (tokenData, { rejectWithValue }) => {
      try {
        const response = await createLinkedInSignin(tokenData);
        return response;
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    }
  );
  
  export const linkedInSignupAuthentication = createAsyncThunk(
    "auth/linkedInSignup",
    async (tokenData, { rejectWithValue }) => {
      try {
        const response = await createLinkedInSignup(tokenData);
        return response;
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    }
  );

  export const accountVerification = createAsyncThunk(
    "auth/verify",
    async (token, { rejectWithValue }) => {
      try {
        const response = await verifyAccount(token);
        return response;
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    }
  );

  export const resendVerificationEmail = createAsyncThunk(
    "auth/resendVerification",
    async (email, { rejectWithValue }) => {
      try {
        const response = await resendVerification(email);
        return response;
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    }
  );
  
